import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { Http, Headers, RequestOptions } from '@angular/http';
import { environment } from 'environments/environment';
import "rxjs/add/operator/map";
import { _firebaseAppFactory } from 'angularfire2/firebase.app.module';
import { FirebaseFirestore } from '@firebase/firestore-types';

declare var firebase;

@Injectable()
export class ChatFirebaseService {

    public firebase: FirebaseFirestore;
    
    protected token = sessionStorage.getItem('token')
    protected headers = new Headers({
        'Content-Type': 'application/json',
        'Authorization': this.token,
        'Access-Control-Allow-Origin': '*'
    });
    protected options = new RequestOptions({
        headers: this.headers
    });

    constructor(
        public http: Http,
    ) {
        let fb = _firebaseAppFactory(this.getFirebase(),"FireOther");
        this.firebase = fb.firestore();
    }

    private findUser(user_id) {
        return this.http.get(environment.apiUrl + "/api/v2/admin/asap-user/dados/" + user_id,this.options);
    }

    private getFirebase() {
        let user = JSON.parse( sessionStorage.getItem("loggedUser") );
        let env:any = environment;
        if ((env.firebaseApp) && (env.firebaseApp[user.data.client_id])) {
          return env.firebaseApp[user.data.client_id];
        }
        return env.firebase;
    }

    public newGuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
            return v.toString(16);
        });
    }

    public findChat(owner) {
        let ownerData = JSON.stringify(owner);
        return this.http.post(environment.apiUrl + '/api/v2/client/chat/find',{ owner:ownerData },this.options);
    }

    public registerChat(owner) {
        let ownerData = JSON.stringify(owner);
        let ownerKey = this.newGuid();
        return this.http.post(environment.apiUrl + '/api/v2/client/chat/register',{ chat_id:ownerKey,owner:ownerData },this.options);
    }

    public openChatRoomById(chatId,callback=null) {
        let messagesCollection = this.firebase.collection('chatroom');
        let chatDoc = messagesCollection.doc(chatId);
        messagesCollection = chatDoc.collection("chat"); 
        let messages = messagesCollection.orderBy("date","asc");
        if (callback) {
            callback({
                messagesCollection: messagesCollection,
                messages: messages
            });
        }
    }

    public openChatRoom(owner,callback=null) {
        let loggedUser = JSON.parse(sessionStorage.getItem('loggedUser'));
        this.findChat(owner).subscribe((response) => {
            //console.log("Find:",response);
            let data = response.json();
            if (data.ok) {
                let chatRoom = data.chat.chat_id;
                let messagesCollection = this.firebase.collection('chatroom');
                let chatDoc = messagesCollection.doc(chatRoom);
                messagesCollection = chatDoc.collection("chat"); 
                messagesCollection.add({
                    started_at: new Date(),
                    type:"data",
                    owner: owner
                });
                let messages = messagesCollection.orderBy("date","asc");
                if (callback) {
                    callback({
                        messagesCollection: messagesCollection,
                        messages: messages
                    });
                }
            }
            else {
                this.registerChat(owner).subscribe((register) => {
                    let chatRoom = register.json().chat.chat_id;
                    let messagesCollection = this.firebase.collection('chatroom');
                    let chatDoc = messagesCollection.doc(chatRoom);
                    owner.id = chatRoom;
                    owner.users = [{
                        user_id: loggedUser.data.id,
                        name: loggedUser.data.name,
                        picture: loggedUser.data.picture
                    }];
                    if (owner.user_id) {
                        this.findUser(owner.user_id).subscribe((response:any) => {
                            response = response.json()[0];
                            console.log("findUser:Response",response);
                            owner.users = [{
                                user_id: response.id,
                                name: response.name,
                                picture: response.picture
                            }];
                            console.log("findUser",owner);
                            chatDoc.update(owner);
                        });
                    }
                    chatDoc.set(owner);
                    messagesCollection = chatDoc.collection("chat");
                    messagesCollection.add({
                        date: new Date(),
                        type:"data",
                        owner: owner
                    });
                    let messages = messagesCollection.orderBy("date","asc");
                    if (callback) {
                        callback({
                            messagesCollection: messagesCollection,
                            messages: messages
                        });
                    }
                });
            }
        });
    }

    public sendMessage(chatRoom, message) {
        let loggedUser = JSON.parse(sessionStorage.getItem('loggedUser'));
        let messageData = {
            type: "message",
            date: new Date(),
            message: message,
            user: {
                user_id: loggedUser.data.id,
                name: loggedUser.data.name,
                picture: loggedUser.data.picture
            }
        }
        chatRoom.parent.get().then((doc) => {
            let channel = doc.data();
            channel.lastMessage = messageData;
            if (channel.users) {
                if (channel.users.indexOf(messageData.user) < 0) {
                    channel.users.push(messageData.user);
                }
            }
            else {
                channel.users = [messageData.user];
            }
            doc.ref.set(channel);
        });
        //console.log("SendMessage:",messageData);
        chatRoom.add(messageData);
    }

}



// WEBPACK FOOTER //
// ./src/app/@core/components/chat-firebase/chat-firebase.service.ts